export enum FILE_TYPE {
  IMAGE = 'images',
  EXCEL = 'excel',
  PDF = 'pdf',
  DOCS = 'docs',
  VIDEO = 'video',
  UNKNOWN = 'unknown'
}
